import { useTranslation } from "react-i18next";
import Tabs from "../../components/Tabs";

import UserData from "../../features/user/UserData";

const UserSettings = () => {
	const { t } = useTranslation();

	const tabs = [
		{
			label: t("user_data"),
			content: <UserData />,
		},
	];

	return <Tabs ariaLabel={t("settings")} tabs={tabs} />;
};

export default UserSettings;
